export default "__VITE_ASSET__BAEVgtdu__"